<template>
  <div id="app">
    <!-- Preloader -->
    <div class="preloader d-flex align-items-center justify-content-center" v-if="loading">
        <div class="cssload-container">
            <div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
        </div>
    </div>
    <!-- <cookie-law theme="blood-orange--rounded" buttonText="Accept" :theme="'base'"></cookie-law> -->
    <cookie-law buttonText="Accept" theme="base">
      <div slot="message">
          This website uses cookies to ensure you get the best experience on our website. <a class="link" href="https://www.malahini.mv/cookie_policy.html">Learn more</a>
        </div>
      
    </cookie-law>
    <b-navbar id="test" toggleable="md" type="light" variant="none" fixed="top">
        <b-navbar-brand href="#/"><img id="logo" :src="logo" alt=""></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="ml-auto w-100 justify-content-end d-none d-sm-inline-flex">
          <span  v-for="(item, index) in menus" :key="index">
              <b-nav-item :href="item.MenuLink" v-if="item.Submenu.length <= 0" :id="'menu' + index">
                  <span v-html="item.MenuName" :style="{'color' : checkActive(item) ? '#5da9ae' : 'inherit', 'line-height' : 2.4}"></span>
              </b-nav-item>
              <b-nav-item  v-else :href="item.MenuLink">
                <b-nav-item-dropdown  left ref="dropdown" :id="'menu' + index" @mouseover="showDrop(index)"  >
                  <template v-slot:button-content>
                      <span v-html="item.MenuName" :style="{'color' : checkActive(item) ? '#5da9ae' : 'inherit'}"></span>
                  </template>
                  <b-dropdown-item   v-for="(sub, key) in item.Submenu" :href="sub.MenuLink" :key="key">{{sub.MenuName}}</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-nav-item>
          </span>
          <b-nav-item id="bookButton" class="hideButton" target="_blank" href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms">
              <a target="_blank" href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms" class="btn palatin-btn d-none d-sm-block" style="background-color: #5da9ae; color: white; font-weight: bold;">Book Now</a>
              <a target="_blank" class="btn palatin-btn  d-inline-block d-sm-none" style="background-color: #5da9ae; color: white; font-weight: bold;">Book Now</a>
          </b-nav-item>
          <b-nav-item data-toggle="modal" data-target="#menuDialog" class="">
            <i class="fa fa-bars mr-2" style="font-size: 18px"></i>
          </b-nav-item>
        </b-navbar-nav>
        <b-collapse class="nav-bar  shadow" ref="navCollapse" id="nav-collapse" is-nav style="">
          <b-card class="mobile-nav d-block d-sm-none" no-body style="border: none">
              <div class="accordion" role="tablist" v-for="(item, index) in menus" :key="index">
                <b-card no-body style="border: none">
                  <b-card-header header-tag="header" class="p-3" role="tab" style="background: none">
                    <a @click.prevent="handleMenuClick(item)" v-b-toggle.accordion-1="`acc-` + index" v-html="item.MenuName" :style="{'color' : checkActive(item) ? '#5da9ae' : 'inherit', 'font-size' : '16px'}"></a>
                  </b-card-header>
                  <b-collapse :id="`acc-` + index" accordion="my-accordion" role="tabpanel">
                    <b-card no-body style="border: none">
                      <b-list-group>
                        <b-list-group-item v-for="(sub, key) in item.Submenu" :href="sub.MenuLink" :key="key">{{sub.MenuName}}</b-list-group-item>
                      </b-list-group>
                    </b-card>
                  </b-collapse>
                </b-card>
              </div>

              <a target="_blank" href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms" class="btn palatin-btn" style="background-color: #5da9ae; color: white; font-weight: bold;">Book Now</a>
              <!-- <div id="bookButton" class="hideButton" target="_blank" href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms">
                  <a target="_blank" class="btn palatin-btn  d-inline-block d-sm-none" style="background-color: #5da9ae; color: white; font-weight: bold;">Book Now</a>
              </div> -->
          </b-card>
        </b-collapse>
    </b-navbar>

    <div id="book-panel">
      <div class="card card-body" style="background-color: #0000009e; border-radius: 0; z-index: 11">
          <div class="row">
              <div class="col-6" style="border-right: solid;border-right-color: white;border-right-width: 1px;margin-bottom: 11px;">
                  <span id="checkInDate">
                      <p class="text-center" style="color: whitesmoke;line-height: 1.4;" @click="datePicker = !datePicker">
                          <span id='checkinDate' class="h3">{{bookStartDate | moment('DD')}}</span> <br>
                          <small id = 'checkinMonth'>{{bookStartDate | moment('MMMM YYYY')}}</small><br>
                          Check In</p>
                  </span>
              </div>
              <div class="col-6">
                  <span id="checkInDate">
                      <p class="text-center" style="color: whitesmoke;line-height: 1.4;" @click="datePicker = !datePicker">
                          <span id='checkoutDate' class="h3">{{bookEndDate | moment('DD')}}</span> <br>
                          <small id = 'checkoutMonth'>{{bookEndDate | moment('MMMM YYYY')}}</small><br>
                          Check Out</p>
                  </span>
              </div>
          </div>

          <functional-calendar v-if="datePicker" v-model="calenderData" :configs="calendarConfigs" @choseDay="chooseDay()" ></functional-calendar>

          <div class="row mt-3">
              <div class="col-6">
                  <select v-model="bookAdults" class="form-control-sm mb-3 w-100 bg-transparent white-text" id="adults">
                      <!-- <option value="0">Adult</option> -->
                      <option value="1">1 Adults</option>
                      <option value="2" selected>2 Adults</option>
                      <option value="3">3 Adults</option>
                      <option value="4">4 Adults</option>
                  </select>
              </div>
              <div class="col-6">
                  <select v-model="bookChildrens" class="form-control-sm mb-3 w-100 bg-transparent white-text" id="childrens" >
                      <option value="0" selected>0 Children</option>
                      <option value="1">1 Children</option>
                      <option value="2">2 Childrens</option>
                      <option value="3">3 Childrens</option>
                      <option value="4">4 Childrens</option>
                  </select>
              </div>
          </div>
          
          <select v-model="bookRooms" class="form-control-sm mb-3 bg-transparent white-text" id="roomsBook">
              <!-- <option value="0" disabled selected>Room</option> -->
              <option value="1" selected>1 Room</option>
              <option value="2">2 Rooms</option>
              <option value="3">3 Rooms</option>
              <option value="4">4 Rooms</option>
          </select>
          
          <a id="bookBox" target="_blank"  :href="'https://reservations.travelclick.com/108582?HotelId=108582&themeId=15328&Languageid=EN_US&locale=EN&DateOut=' + formatLinkDate(bookStartDate) + '&DateIn=' + formatLinkDate(bookEndDate) + '&Adults=' + bookAdults + '&Children=' + bookChildrens + '&Rooms=' + bookRooms + '#/accommodation/room'" class="btn palatin-btn text-white">Book Now</a>
      </div>
    </div>

    <!-- menu modal -->
    <div id="menuDialog" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" style="background-color: #ffffffdb">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body p-5">
                    <h5><img src="./assets/img/core-img/logo.png" alt=""></h5>
                    <div class="row mt-50  justify-content-md-center">
                        <div class="col-md-3" v-for="(menu, index) in menuList" :key="index">
                            <ul>
                                <li v-for="(m, index) in menu" :key="index" class="mb-4">
                                    <a  @click="closeModal" :href="m.MenuLink"><h5><strong v-html="m.MenuName"></strong></h5></a>
                                    <ul>
                                        <li v-for="(sub, i) in m.Submenu" :key="i">
                                            <a :href="sub.MenuLink" @click="closeModal" v-html="sub.MenuName"></a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div v-if="index === menuList.length - 1">
                              <h5 style="margin-top: -50px;"><strong>Contact Info</strong></h5>
                              <ul>
                                <li>
                                  Malahini Kuda Bandos, North Male' Atoll, Republic of Maldives
                                </li>
                                <li>
                                  <a href="tel:+9606644556">+960 6644556</a>
                                </li>
                                <li>
                                  <a href="mailTo:reservations@malahini.mv">reservations@malahini.mv</a>
                                </li>
                              </ul>
                            </div>
                        </div>
                    </div>                   
                </div>                    
            </div>
        </div>
    </div>
    <!-- End of menu modal -->
    
    <router-view :key="$route.fullPath"></router-view>

    <!-- {{$route}} -->
    <!-- ##### Footer Area Start ##### -->
    <footer class="footer-area">
      <div class="container">
        <div  id="footerLinks">
          <div class="row pt-5">
              <!-- <div class="col-md-2">
                <h4 style="color: white" data-wow-delay="300ms">Malahini Kuda Bandos, North Male' Atoll , Republic of Maldives</h4>
                <h5 class="footer-links" data-wow-delay="400ms"> +960 664 4556</h5>
                <h5 class="footer-links" data-wow-delay="500ms">reservations@malahini.mv</h5>
              </div> -->
              <div class="col-md-2">
                  <ul>
                      <li class="mb-4">
                          <a href="#/page/rooms/tile0"><h5 class="footer-heading"><strong>Rooms</strong></h5></a> 
                          <ul>
                            <li><a class="footer-links" href="#/page/rooms/tile0">Sunset Beach Pool Suite</a></li>
                            <!-- <li><a class="footer-links" href="#/page/rooms/tile1">3 Bedroom Beach Pool Villa</a></li>
                            <li><a class="footer-links" href="#/page/rooms/tile2">2 Bedroom Beach Pool Villa</a></li> -->
                            <li><a class="footer-links" href="#/page/rooms/tile1">Sunrise Beach Pool Villa</a></li>
                            <li><a class="footer-links" href="#/page/rooms/tile2">Deluxe Room</a></li>
                            <li><a class="footer-links" href="#/page/rooms/tile3">Superior Room</a></li>
                            <li><a class="footer-links" href="#/page/rooms/tile4">Garden Room</a></li>
                          </ul>
                      </li>
                      <li class="mb-4"><a href="#/page/specialoffers"><h5 class="footer-heading"><strong>Special Offers</strong></h5></a> <ul></ul></li>
                      
                  </ul>
              </div>
              <div class="col-md-2">
                  <ul>
                      <li class="mb-4"><a href="#/page/experience"><h5 class="footer-heading"><strong>Experience</strong></h5></a> 
                          <ul><li><a class="footer-links" href="#/page/experience/tile0">Excursions</a></li><li><a class="footer-links" href="#/page/experience/tile1">Diving</a></li><li><a class="footer-links" href="#/page/experience/tile2">Snorkelling</a></li><li><a class="footer-links" href="#/page/experience/tile3">Watersports</a></li><li><a class="footer-links" href="#/page/experience/tile4">Spa</a></li><li><a class="footer-links" href="#/page/experience/tile5">Flex</a></li><li><a class="footer-links" href="#/page/experience/tile6">Night Fishing &amp; Big Game Fishing</a></li><li><a class="footer-links" href="#/page/experience/tile7">Night Entertainment</a></li><li><a class="footer-links" href="#/page/experience/tile8">Festive Highlights</a></li></ul>
                      </li>
                      
                  </ul>
              </div>
              <div class="col-md-2">
                  <ul>
                      <li class="mb-4">
                          <a href="#/page/eatanddrink"><h5 class="footer-heading"><strong>Eat &amp; Drink</strong></h5></a> 
                          <ul><li><a class="footer-links" href="#/page/eatanddrink/tile0">Maaga</a></li><li><a class="footer-links" href="#/page/eatanddrink/tile1">Bluu</a></li><li><a class="footer-links" href="#/page/eatanddrink/tile2">Bar 75</a></li><li><a class="footer-links" href="./files/IRD-menue.pdf">Inroom Dining</a></li><li><a class="footer-links" href="./files/beach_dinner_menu.pdf">Beach Dinner</a></li></ul>
                      </li>
                  </ul>
              </div>
              <div class="col-md-2">
                  <ul>
                      <li class="mb-4"><a href="#/page/weddings"><h5 class="footer-heading"><strong>Weddings</strong></h5></a> 
                          <ul><li><a class="footer-links" href="#/page/weddings/tile0">Weddings</a></li><li><a class="footer-links" href="#/page/weddings/tile1">Honeymoon</a></li><li><a class="footer-links" href="#/page/weddings/tile2">Proposal</a></li></ul>
                      </li>
                      <li class="mb-4">
                        <a href="#/page/wecare">
                        <h5 class="footer-heading">
                          <strong><i class="fa fa-leaf"></i> We Care</strong></h5>
                          </a>
                          
                          <ul>
                            <li><small><a href="#/page/wecare/tile1" class="footer-links">Green Goals</a></small></li>
                            <li><small><a href="#/page/wecare/tile0" class="footer-links">Corporate Social Responsibility</a></small></li>
                          </ul>
                      </li>
                  </ul>
              </div>
              <div class="col-md-2">
              <ul>
                  <li class="mb-4">
                      <a href="#/page/ourstory"><h5 class="footer-heading"><strong>Our Story</strong></h5></a> 
                      <ul><li><a class="footer-links" href="#/page/ourstory/tile0">Useful Information</a></li><li><a class="footer-links" href="#/page/ourstory/tile1">Awards</a></li><li><a class="footer-links" href="#/reviews">Reviews</a></li><li><a class="footer-links" href="#/page/ourstory/tile4">Discover Who We Are</a></li><li><a class="footer-links" href="./files/map.pdf">Map of the Resort</a></li><li><a class="footer-links" href="./files/brochure.pdf">Brochure</a></li></ul>
                  </li>
                  <li class="mb-4"><a href="#/gallery"><h5 class="footer-heading"><strong>Gallery</strong></h5></a> <ul></ul></li>
                  <li class="mb-4"><a href="https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Aerial_Overview"><h5 class="footer-heading"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;width: 35px;fill: rgba(204, 204, 204, 0.4);" xml:space="preserve"><g>	<g>		<path d="M252.242,174.231c-11.651,0-22.288,4.422-30.326,11.672V171.46c0-16.722,13.604-30.326,30.326-30.326			c6.848,0,13.308,2.226,18.684,6.437c3.261,2.555,7.976,1.981,10.529-1.279c2.555-3.261,1.982-7.975-1.279-10.529			c-8.041-6.299-17.7-9.628-27.934-9.628c-24.993,0-45.326,20.333-45.326,45.326v52.606c0,24.993,20.333,45.326,45.326,45.326			s45.326-20.333,45.326-45.326v-4.51C297.568,194.564,277.235,174.231,252.242,174.231z M282.568,224.066			c0,16.722-13.604,30.326-30.326,30.326s-30.326-13.604-30.326-30.326v-4.509c0-16.722,13.604-30.326,30.326-30.326			s30.326,13.604,30.326,30.326V224.066z"/>	</g></g><g>	<g>		<path d="M166.199,179.853c5.639-5.703,9.125-13.537,9.125-22.171c0-17.396-14.152-31.548-31.548-31.548			c-7.776,0-15.246,2.854-21.036,8.036c-3.086,2.763-3.348,7.504-0.585,10.59s7.503,3.349,10.59,0.586			c3.034-2.716,6.952-4.212,11.031-4.212c9.125,0,16.548,7.423,16.548,16.548s-7.423,16.549-16.548,16.549			c-4.142,0-7.5,3.357-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5c17.965,0,32.581,14.615,32.581,32.58			c-0.002,17.966-14.618,32.582-32.583,32.582c-10.353,0-19.859-4.758-26.082-13.053c-2.486-3.313-7.186-3.984-10.5-1.499			c-3.313,2.486-3.984,7.187-1.499,10.5c9.083,12.107,22.963,19.051,38.082,19.051c26.236,0,47.581-21.345,47.581-47.581			C191.356,203.678,181.159,187.881,166.199,179.853z"/>	</g></g><g>	<g>		<path d="M356.201,126.134c-24.026,0-43.573,19.546-43.573,43.573v56.113c0,24.026,19.547,43.573,43.573,43.573			s43.573-19.547,43.573-43.573v-56.113C399.774,145.681,380.227,126.134,356.201,126.134z M384.774,225.82			c0,15.755-12.818,28.573-28.573,28.573s-28.573-12.818-28.573-28.573v-56.113c0-15.755,12.818-28.573,28.573-28.573			s28.573,12.818,28.573,28.573V225.82z"/>	</g></g><g>	<g>		<path d="M420.331,78.037c-15.186,0-27.54,12.354-27.54,27.541c0,15.186,12.354,27.54,27.54,27.54			c15.186,0,27.541-12.354,27.541-27.54C447.872,90.392,435.518,78.037,420.331,78.037z M420.331,118.119			c-6.915,0-12.54-5.625-12.54-12.54c0-6.916,5.625-12.541,12.54-12.541c6.915,0,12.541,5.625,12.541,12.541			C432.872,112.494,427.247,118.119,420.331,118.119z"/>	</g></g><g>	<g>		<path d="M268.364,401.452l-47.554-25.885c-3.637-1.98-8.192-0.637-10.173,3.001s-0.636,8.193,3.002,10.173l17.035,9.272			c-55.602-2.928-107.055-15.471-146.951-36.062C39.407,339.079,15,309.237,15,277.925c0-38.061,37.123-74.471,99.304-97.397			c3.886-1.433,5.875-5.745,4.442-9.631c-1.433-3.886-5.742-5.875-9.632-4.442c-32.535,11.996-59.651,28.066-78.418,46.472			C10.614,232.622,0,255.098,0,277.925c0,37.205,27.291,71.78,76.844,97.356c41.569,21.455,94.885,34.551,152.322,37.669			l-17.85,6.459c-3.895,1.409-5.91,5.709-4.5,9.604c1.104,3.052,3.984,4.95,7.053,4.95c0.847,0,1.709-0.145,2.552-0.45			l50.911-18.423c2.775-1.004,4.703-3.543,4.926-6.486C272.481,405.661,270.957,402.863,268.364,401.452z"/>	</g></g><g>	<g>		<path d="M499.865,303.666c-3.697-1.867-8.208-0.383-10.076,3.315c-1.076,2.13-2.288,4.277-3.603,6.381			c-2.195,3.513-1.127,8.14,2.386,10.335c1.236,0.773,2.61,1.141,3.967,1.141c2.5,0,4.945-1.25,6.368-3.526			c1.555-2.488,2.992-5.035,4.272-7.571C505.046,310.044,503.562,305.533,499.865,303.666z"/>	</g></g><g>	<g>		<path d="M472.624,341.068c-2.636-3.196-7.362-3.649-10.557-1.012c-4.052,3.344-8.477,6.63-13.153,9.768			c-3.439,2.308-4.356,6.967-2.048,10.407c1.447,2.157,3.818,3.322,6.234,3.322c1.437,0,2.89-0.412,4.172-1.273			c5.085-3.412,9.91-6.996,14.341-10.653C474.808,348.99,475.26,344.264,472.624,341.068z"/>	</g></g><g>	<g>		<path d="M426.183,371.504c-1.701-3.777-6.141-5.461-9.919-3.758c-4.947,2.229-10.133,4.38-15.414,6.394			c-3.87,1.476-5.812,5.81-4.335,9.68c1.141,2.991,3.988,4.83,7.009,4.83c0.888,0,1.792-0.159,2.671-0.494			c5.555-2.119,11.016-4.384,16.231-6.734C426.202,379.72,427.884,375.28,426.183,371.504z"/>	</g></g><g>	<g>		<path d="M374.051,390.892c-1.033-4.011-5.126-6.426-9.134-5.393c-5.335,1.374-10.84,2.662-16.361,3.83			c-4.053,0.857-6.643,4.836-5.787,8.889c0.746,3.529,3.861,5.95,7.331,5.95c0.514,0,1.036-0.053,1.559-0.164			c5.734-1.212,11.454-2.551,16.999-3.979C372.669,398.992,375.084,394.903,374.051,390.892z"/>	</g></g><g>	<g>		<path d="M319.513,402.018c-0.49-4.113-4.219-7.053-8.335-6.56c-2.583,0.308-5.22,0.598-7.836,0.863			c-4.121,0.417-7.124,4.096-6.707,8.217c0.391,3.865,3.65,6.745,7.453,6.745c0.253,0,0.508-0.013,0.765-0.039			c2.704-0.274,5.429-0.574,8.1-0.892C317.066,409.862,320.003,406.131,319.513,402.018z"/>	</g></g><g>	<g>		<path d="M488.561,220.625c-14.53-16.74-35.06-31.486-61.017-43.828c-3.743-1.779-8.216-0.188-9.994,3.553			c-1.778,3.741-0.188,8.215,3.553,9.994C469.336,213.277,497,245.199,497,277.925c0,4.142,3.358,7.5,7.5,7.5			c4.142,0,7.5-3.358,7.5-7.5C512,257.822,504.114,238.544,488.561,220.625z"/>	</g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></h5></a> <ul></ul></li>
              </ul>
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-md-6">
          <h5 class="footer-heading"><strong>Contact Info</strong></h5>
          <!-- <h4 style="color: white; font-weight: bolder;" data-wow-delay="300ms">Malahini Kuda Bandos</h4> -->
          <h5 style="color: grey">Malahini Kuda Bandos, North Male' Atoll , Republic of Maldives</h5>
          <h5 class="footer-links" data-wow-delay="400ms"> +960 664 4556</h5>
          <h5 class="footer-links" data-wow-delay="500ms">reservations@malahini.mv</h5>
        </div>
        <div class="col-md-4">
          <h5 class="footer-heading"><strong>Connect With Us</strong></h5>
          <!-- Social Info -->
          <div class="social-info wow fadeInUp mt-10 mb-2" data-wow-delay="600ms">
              <!-- <a href="#"><i class="fa fa-pinterest"></i></a> -->
              <a class="white-text mr-3" href="https://www.facebook.com/kudabandos/"><i class="fab fa-facebook-f"></i></a>&nbsp;&nbsp;&nbsp;
              <a class="white-text mr-3" href="https://twitter.com/malahiniresort"><i class="fab fa-twitter" aria-hidden="true"></i></a>&nbsp;&nbsp;&nbsp;
              <a class="white-text" href="https://www.instagram.com/malahinikb/"><i class="fab fa-instagram"></i></a>
              <!-- <a href="#"><i class="fa fa-behance" aria-hidden="true"></i></a> -->
              <!-- <a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a> -->
          </div>
        </div>
      </div>

      <!-- Copywrite Text -->
      <div class="pl-3">
          <div class="copywrite-text">
              <p>

  Copyright &copy;
  {{year}}
  All rights reserved </p>
          </div>
      </div>
    </div>
  </footer>
  <!-- ##### Footer Area End ##### -->


  </div>
</template>
<script>
import {_} from 'vue-underscore';
import $ from 'jquery'
import 'bootstrap';
import { FunctionalCalendar } from 'vue-functional-calendar';
import moment from 'moment'
import CookieLaw from 'vue-cookie-law';
// import mainNav from './components/Nav.vue'
// import Home from './components/Home.vue'

// window.addEventListener("load", function(){window.wpcc.init({"colors":{"popup":{"background":"#edfdfa","text":"#000000","border":"#5ec2b6"},"button":{"background":"#5ec2b6","text":"#ffffff"}},"position":"bottom","padding":"none","margin":"none","transparency":"15","content":{"href":"https://www.malahini.mv/cookie_policy.html","button":"Accept"}})});

var axel = Math.random() + "";
var a = axel * 10000000000000;
document.write('<iframe src="https://5810867.fls.doubleclick.net/activityi;src=5810867;type=websi780;cat=malah123;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1;num=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');


// var adv_sub = '%JS_ConfirmNo%'+ '  '+ '%JS_HName%';
// var adv_sub2 ='%DepartDtYYYYMMDD%';  
// var adv_sub3 ='%JS_HOTEL_ID%' ;
// var adv_sub4 ='%JS_TotalCost%:%JS_CurrCode%'; 
// var amount = '%JS_TotalCost%';

// /* VARIABLE SECTION END */
//     var  glop_id = 384;
//     var  adv_pixel_url =  '//lamp.glopss.com/aff_l?offer_id='+glop_id+'&amount='+amount; 
//         adv_pixel_url = adv_pixel_url + '&adv_sub='+adv_sub+'&adv_sub2='+adv_sub2+'&adv_sub3='+adv_sub3; 
//         adv_pixel_url = adv_pixel_url + '&adv_sub4='+adv_sub4;
    
// (function() { 
//     var glopImage = new Image(1, 1);
//     glopImage.src = adv_pixel_url;
//     // document.body.appendChild(glopImage);   
//     })();



export default {
  name: 'app',
  data: ()=>({
    loading: true,
    
    menus: [],
    menuList: [],
    scrolled: false,
    scrollPosition: 0,
    logo: require('@/assets/img/core-img/logo-white.png'),
    menuModal: false,
    year: '',
    dateOne: '',
    dateTwo: '',
    bookStartDate: moment().add(2, 'days'),
    bookEndDate: moment().add(4, 'days'),
    bookModalIn: moment().add(2, 'days').format('DD-MM-YYYY'),
    bookModalOut: moment().add(4, 'days').format('DD-MM-YYYY'),
    markedDateRange: {start: '12/12/2018', end: '20/12/2018'},
    calenderData: {},
    calendarConfigs: {
      sundayStart: true,
      markedDateRange: {},
      isDateRange: true,
      dateFormat: 'yyyy-mm-dd'
    },
    datePicker: false,
    bookRooms: 1,
    bookChildrens: 0,
    bookAdults: 2,
    isMobile: false,
    packages: [
      'Group Dive',
      'Children Stay Free',
      'Surf @ Malahini ',
      'Summer Honeymoon',
      'Watersports',
      'Dive',
      'Honeymoon #atMalahini',
      'Stay Longer & Save more!'
    ]

    

  }),
  components: {'functional-calendar' : FunctionalCalendar, CookieLaw},
  created () {
    // this.calendarConfigs.markedDateRange = {start: '02/02/2020', end: '20/02/2020'}
    // this.calenderData.dateRange = {}
    // console.log(this.$route)
    
    // this.calenderData.dateRange.start = moment(this.bookStartDate)
    // this.calenderData.dateRange.end = moment(this.bookEndDate)
    // this.calendarConfigs.markedDateRange = {start: moment(this.bookStartDate).format('DD/MM/YYYY').toString(), end: moment(this.bookEndDate).format('DD/MM/YYYY').toString()}
  },
  mounted() {
    // Dynamically load the external script
    const script1 = document.createElement("script");
    script1.src = "https://static.123compareme.com/CmprmInit-min.js";
    script1.type = "text/javascript";
    document.head.appendChild(script1);

    // Listen for the script load event
    script1.onload = () => {
      // Initialize the CmprmInit after the script has loaded
      document.addEventListener('CmprmInitLoaded', function(event) {
        CmprmInit.InitK8(278);
      }, false);
    };

    var axel = Math.random() + "";
    var a = axel * 10000000000000;
    document.write('<iframe src="https://6974167.fls.doubleclick.net/activityi;src=6974167;type=invmedia;cat=malah0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');

    // console.log(moment(this.bookStartDate).format('DD/MM/YYYY').toString(), moment(this.bookEndDate).format('DD/MM/YYYY').toString())
    // this.calendarConfigs.markedDateRange = {start: moment(this.bookStartDate).format('DD/MM/YYYY').toString(), end: moment(this.bookEndDate).format('DD/MM/YYYY').toString()}
    // document.getElementById("modalCheckInDate").value = this.bookModalIn
    // document.getElementById("modalCheckOutDate").value = '02-02-2020'
    this.loading = false
    let date = new Date()
    this.year = date.getFullYear()
    this.$http.get('https://www.malahini.mv:9443/web/api/menu').then((respose)=>{
        let datas = _.where(respose.data, {IsMainMenu: true})
        this.menus = _.sortBy(datas, 'MenuPosition')

        for (let page of this.menus) {
            page.Submenu = _.sortBy(page.Submenu ,'MenuPosition')
        }
        
        // console.log(this.menus, 'im here')
        setTimeout(() => {
          let allData = _.sortBy(respose.data, 'MenuPosition')
            this.menuList = _.chunk(allData, 3)
        }, 500);
    });
     
    // const url = 'https://test.malahini.mv:8443/web/api/menu'; // Get pageMenus
    // let pageMenus;
    // fetch(url) // Call the fetch function passing the url of the API as a parameter
    // .then((resp) => resp.json()) // Transform the data into json
    // .then((data) => {
    //     // Your code for handling the data you get from the API
    //     pageMenus = _.sortBy(data, 'MenuPosition'); // Get the sorted results
    //     this.menuList = pageMenus
    //     // console.log(this.menuList)
        
    // })
    // .catch(function() {
    //     // This is where you run code if the server returns any errors
    // });

    // var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
        this.isMobile = true;
    }
    

    if (!this.isMobile) {
      window.addEventListener('scroll', function(){
        this.scrollPosition = document.documentElement.scrollTop
        let navTab = document.getElementById('test')
        let pview = document.getElementById('360')

        // console.log(this.scrollPosition)
        if (this.scrollPosition > 50) {
          document.getElementById("logo").src = require('@/assets/img/core-img/logo.png')
          this.scrolled = true
          // document.getElementById("bookButton").style.display = "block";

          if (navTab.classList) {
            // console.log(navTab.classList)
            navTab.classList.add('nav-scroll')
            if (pview) {

              pview.style.fill="black"
            }
          }
          document.getElementById("bookButton").classList.add('displayButton')
          document.getElementById("bookButton").classList.remove('hideButton')
        } else {
          this.scrolled = false

          document.getElementById("logo").src = require('@/assets/img/core-img/logo-white.png')
          navTab.classList.remove('nav-scroll')
          if (pview) {

              pview.style.fill="white"
            }
          // document.getElementById("bookButton").style.display = "none";
          document.getElementById("bookButton").classList.remove('displayButton')
          document.getElementById("bookButton").classList.add('hideButton')
        }
      });
    }
    else {
      this.logo = require('@/assets/img/core-img/logo.png')
      setTimeout(() => {
         let pview = document.getElementById('360')
          if (pview) {
            pview.style.fill="black"
          }
       }, 400);
      if (document.getElementById("bookButton")) document.getElementById("bookButton").classList.add('displayButton')
      if (document.getElementById("bookButton")) document.getElementById("bookButton").classList.remove('hideButton')
    }

  },
  beforeDestroy() {
    // Cleanup the event listener when the component is destroyed
    document.removeEventListener('CmprmInitLoaded', this.cmprmInitListener);
  },
  watch: {
    // bookEndDate: function(val) {
    //   this.calendarConfigs.markedDateRange = {start: moment(this.bookStartDate).format('DD/MM/YYYY').toString(), end: moment(val).format('DD/MM/YYYY').toString()}

    // },
    // bookStartDate: function (val) {
    //   this.calendarConfigs.markedDateRange = {start: moment(val).format('DD/MM/YYYY').toString(), end: moment(this.bookEndDate).format('DD/MM/YYYY').toString()}

    // }
    $route () {
      this.$refs.navCollapse.show = false
    }
  },
  // components: {
  //   mainNav, Home
  // },
  methods: {
    handleMenuClick(item) {
      if (item.Submenu.length <= 0) {
        window.location.href = item.MenuLink;
      }
    },
    closeModal() {
      $('#menuDialog').modal('hide')
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    chooseDay(value) {
      // console.log(this.calenderData.dateRange)
      if (this.calenderData.dateRange.start.date) {
      this.bookStartDate = moment(this.calenderData.dateRange.start.date)
      this.bookEndDate = moment(this.bookStartDate).add(4, 'days')
      // console.log(this.bookStartDate)
      
      }
      if (this.calenderData.dateRange.end.date) {
      this.bookEndDate = this.calenderData.dateRange.end.date
      
      }
    },
    checkActive(item) {
        let itemPath = item.MenuLink
        let arr = itemPath.split('/')
        arr.shift()

        let routeLink = this.$route.path
        let arr2 = routeLink.split('/') 
        // console.log(arr2)
        if (arr[0] == arr2[1]) {
          if(arr[1] == arr2[2]) {
            return true
          } else {
            return false
          }
        }
        else  {

        }
        
        
        // console.log('lolol', arr2[arr2.length-1])

    },
    formatLinkDate(date) {
      return moment(date).format('MM/DD/YYYY')
    }
  }
  
}
</script>

<style lang="scss">
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: "FuturaLT-Book";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  // margin-top: 60px;
}
.full-height {
  height: 100vh !important;
}
.carousel-item.active>img {
  -webkit-animation: slide 20s linear infinite;
    animation: slide 20s linear infinite;
}


.fullscreen-bg {
    // position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: -100;
}

.fullscreen-bg__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
}
@media (min-aspect-ratio: 16/9) {
  .fullscreen-bg__video {
    height: 300%;
    top: -100%;
  }
}


@media (max-aspect-ratio: 16/9) {
  .fullscreen-bg__video {
    // width: 300%;
    // left: -150%;
    // min-width: 300%;
    min-height: 100%;
    width: auto;
    // height: auto;
  }
}

@media only screen and (max-width: 768px) {
  .fullscreen-bg__video {
      // width: 300%;
      left: -145%;
      // min-width: 300%;
      min-height: 100%;
      width: auto;
      // height: auto;
    }
}
.caro-indicators {
  position: absolute; 
  bottom: 10px; 
  z-index: 10
}
.list-inline-item.active {
  color: #ffffff;
  background-color: #5da9ae;
  // border: 2px solid #5da9ae;

  opacity: 1;
  box-shadow: none;
  // padding: 3px 5px;
  // font-size: 10px;
  border-radius: 50%;
  height: 15px;
}
.list-inline-item {
  color: #ffffff;
  background-color: black;
  opacity: .2;
  // border: 2px solid #dadada;
  box-shadow: none;
  // padding: 3px 5px;
  // font-size: 5px;
  height: 15px;
  border-radius: 100%

}
.list-inline-item>button {
  padding: 1px 6px; 
  text-decoration: none;
}
.carousel-indicators {
  display: none
}
.bg-none {
    background-color: transparent !important
}
.dropdown-toggle::after {
    font-family: 'classyfonts';
    content: "\e900";
    font-size: 12px;
    color: #ffffff;
    padding-left: 5px;
    -webkit-transition-duration: 500ms;
    transition-duration: 500ms;
    border: none;
}
.navbar-nav>ul>li>a, .navbar-light .navbar-nav .nav-link {
    font-family: "Cicle_Fina";
    /* font-weight: bold; */
    font-size: 18px !important;
    // padding-right: 20px;
    // line-height: 40px;
    font-weight: 700;
    // color: white;
}
.nav-item.dropdown {

}

.nav-scroll { 
  background-color: #ffffff !important;
}

.nav-scroll .navbar-brand {
    color: black;
    -webkit-animation: slide-down .75s ease-out;
    -moz-animation: slide-down .75s ease-out;
}
.displayButton {
  display: block;
    -webkit-animation: slide-down .3s ease-out;
    -moz-animation: slide-down .3s ease-out;
  // opacity: 1;
}
.hideButton {
  display: none;
  // visibility: hidden;    
  transition: all .75s ease;
  opacity: 0;
}

@-webkit-keyframes slide-down {
      0% { opacity: 0; -webkit-transform: translateY(-100%); }   
    100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
      0% { opacity: 0; -moz-transform: translateY(-100%); }   
    100% { opacity: 1; -moz-transform: translateY(0); }
}

.dropdown>.dropdown-menu {
  top: 200%;
  transition: 0.5s all ease-in-out;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  transition-duration: 300ms;
  background-color: #ffffffc4;
  border-radius: 0;
  margin-top: -10px;
}
.dropdown:hover>.dropdown-menu {
  display: block;
  top: 100%;
}
.dropdown-menu>li>a {
  border-bottom: 1px solid rgba(242, 244, 248, 0.7);
}
.dropdown-menu>li:last-child a {
  border-bottom: none;
}
.dropdown>.dropdown-toggle:active {
  /*Without this, clicking will make it sticky*/
    pointer-events: none;
}

@media only screen and (max-width: 767px) {
  .navbar-collapse {
    // background-color: #5da9ae;
  }
  .navbar.navbar-light {
    padding: 0;
    // padding-top: 22px
  }
  .navbar-brand, .navbar-toggler {
    margin: 10px;
  }
  .navbar-light .navbar-toggler {
    border: none;
  }
  .nav-scroll>button.navbar-toggler-icon {
    color: black;
    border: none;
  }
}

  .navbar-collapse.collapse.show {
    background-color: white;
    padding: 30px;
  }

@media only screen and (min-width: 768px) {
  .nav-scroll .navbar-nav .nav-link, .nav-scroll .navbar-nav .nav-link:hover, .nav-scroll .navbar-nav .dropdown-toggle::after {
      color: black !important;
      -webkit-animation: slide-down .75s ease-out;
      -moz-animation: slide-down .75s ease-out;
  }
  .navbar-nav .nav-link {
    color: white !important;
  }
}

.vfc-main-container {
  height: auto !important;
  padding-bottom: 11px
}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content h2.vfc-top-date {
  margin: 17px;
  margin-top: 11px;
}
.vfc-styles-conditional-class .vfc-main-container .vfc-navigation-buttons div {
    margin: 15px 10px;
}
.vfc-styles-conditional-class .vfc-main-container {
  background-color: #ffffffb8;
}
.bg-transparent {
  background-color: transparent;
}
.nav-active>.nav-link {
  color: #5da9ae !important;
}
.modal-book {
  background: transparent;
  border: none !important;
  border-bottom: 1px solid #000000 !important;
  box-shadow: none;
  border-radius: 0 !important;
  -webkit-appearance: none;
}
.modal-book:focus {
  box-shadow: none;
  background-color: transparent;
}
.form-control {
  border-radius: 0;
}
.dropdown-item {
  font-weight: bold !important;
}
#book-panel {
  z-index: 14;
}
.nav-link>i {
  line-height: 2.4
}
.Cookie__button {
  background: #5da8ae !important;
}
.vfc-styles-conditional-class .vfc-multiple-input input:last-child, .vfc-styles-conditional-class .vfc-multiple-input input:first-child {
  border-radius: 0;
}
.vfc-styles-conditional-class .vfc-multiple-input input {
  border: none;
  border-bottom: 1px solid #000 !important;
}
#nav-collapse {
  overflow-y: scroll;
  border: 1px solid rgb(150, 214, 219);
  margin: 10px;
  border-radius: 17px;
}

@media only screen and (max-width: 767px) {
  #nav-collapse {
    height: 83vh;
  }
}
</style>
